import Local from '@/app/module/local'
import Response from '@/app/model/api/response/responseValue'

class FieldDetailsApi {
  public getFieldDetailsData (id: string, fieldFlag: boolean, flag: number, searchList: {[key:string]: any}, ownerList: number[]) {
    const path = '/v1/field/detail'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({})
    /* trueの場合area_id、falseの場合planting_id */
    if (fieldFlag) {
      params.append('area_id', id)

      if (flag === 1) {
        // 圃場検索の場合
        if (searchList.refile) {
          params.append('is_plant', '0')
        } else {
          params.append('is_plant', '1')
        }
        url.search = params.toString()
      } else if (flag === 3) {
        params.append('is_plant', '1')
        if (searchList.status !== '') {
          params.append('growth_stage_id', searchList.status)
        }
        if (searchList.variety !== '') {
          params.append('variety_name', searchList.variety)
        }
        if (searchList.grade !== '') {
          params.append('grade_name', searchList.grade)
        }
        if (searchList.risk !== 0) {
          params.append('risk_id', String(searchList.risk))
        }
        if (searchList.word !== '') {
          params.append('word', String(searchList.word))
        }
        for (var j in ownerList) {
          params.append('field_id[]', String(ownerList[j]))
        }
        url.search = params.toString()
      }
    } else {
      params.append('planting_id', id)
      url.search = params.toString()
    }
    return fetch(decodeURI(url.href), {
      method: 'GET',
      headers: {
        'X-Auth-Token': Local.getAuthToken()!
      }
    })
      .then(response => {
        if (response.status === 200) {
          return response.json()
        } else if (response.status === 400 || response.status === 401 || response.status === 403) {
          return response.json()
        } else {
          throw Error(String(response.status))
        }
      })
      .then(data => {
        if (data.status_code === 0) {
          return new Response(true, data.payload)
        } else {
          throw data
        }
      })
      .catch(e => {
        return new Response(false, e)
      })
  }
}

export default new FieldDetailsApi()
